import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { Injectable } from '@angular/core';
import { GridInput } from '@it2go/data-grid';
import {
    LoanAgreementReminderGridObject,
    LoanAgreementReminderObject,
} from '@libs/types/src/mado/object-type/loan-agreement-reminder.object';
import { LoanAgreementReminderUpdateInput } from '@libs/types/src/mado/input-type/loan-agreement-reminder.update-input';
import { LoanAgreementReminderCreateInput } from '@libs/types/src/mado/input-type/loan-agreement-reminder.create-input';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';

@Injectable({ providedIn: 'root' })
export class LoanAgreementReminderGqlService extends GqlServiceV2 {

    public getLoanAgreementReminders(input: GridInput | null, frag: string) {
        return this.query<LoanAgreementReminderGridObject>(
            `
                query($input: GridInput!) {
                    loanAgreementReminder {
                        filter(input: $input) {
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createLoanAgreementReminder(input: LoanAgreementReminderCreateInput, frag: string) {
        return this.mutate<LoanAgreementReminderObject>(
            `
                mutation($input: LoanAgreementReminderCreateInput!) {
                    loanAgreementReminder {
                        create(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateLoanAgreementReminder(input: LoanAgreementReminderUpdateInput, frag: string) {
        return this.mutate<LoanAgreementReminderObject>(
            `
                mutation($input: LoanAgreementReminderUpdateInput!) {
                    loanAgreementReminder {
                        update(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteLoanAgreementReminder(input: IdInput, frag = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    loanAgreementReminder {
                        delete(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }
}
